/* Load product behavior only when a product component exists, including AJAX quick views. */
(() => {
  if (customElements.get("netlager-product")) return;
  const moduleUrl = document.currentScript.dataset.moduleUrl;
  let loading;
  customElements.define(
    "netlager-product",
    class extends HTMLElement {
      connectedCallback() {
        if (window.NetlagerProduct) {
          window.NetlagerProduct.mount(this);
          return;
        }
        loading ||= import(moduleUrl).catch((error) => {
          loading = undefined;
          console.error("Netlager product behavior could not load", error);
        });
        loading.then(() => {
          if (this.isConnected) window.NetlagerProduct?.mount(this);
        });
      }
      disconnectedCallback() {
        window.NetlagerProduct?.unmount(this);
      }
    },
  );
})();
